import moment from "moment";
import React, { useEffect, useState } from "react";
import { BackButton, TableData } from "../../components";
import { errorAlert } from "../../helpers/alerts";
import { useNavigate } from "react-router-dom";
import { getLastAlertsService } from "services/admin/alertsService";
import { toTitleCase } from "helpers/util";

const PanelAlertsScreen = ({ slim }) => {
  const navigate = useNavigate();
  const [list, setList] = useState([])
  const [loading, setLoading] = useState(false)
  const shortList = new Array(15).fill({});

  useEffect(() => {
    setLoading(true)
    getLastAlertsService().then((response) => {
      setList(response);
    }).catch(error => errorAlert(error))
      .finally(() => setLoading(false));
  }, []);

  return (
    <>
      {!slim && <BackButton name={'Regresar'} click={() => navigate(-1)} />}
      <TableData
        title={"Alertas"}
        onTitleClick={() => slim && navigate('../admin/alertas/eventos')}
        rowsPerPageOpt={50}
        autonumber={false}
        pagination={false}
        loading={loading}
        headerStyle={slim && {
          fontSize: slim ? 10 : 12,
        }}
        dataRows={(slim ? shortList.map((item, i) => list[i] || {}) : list).map((item) => ({
          ...item,
          style: {
            fontSize: slim ? 11 : 12,
          }
        }))}
        dataTitle={[
          "Id",
          "Hora",
          "Instancia",
          "Mensaje",
        ]}
        formatter={({
          identification,
          createdAt,
          providerCredential,
          alert,
          message,
        }) => ([
          identification || '-',
          createdAt ? moment(createdAt).format(slim ? 'HH:mm:ss' : 'DD/MM/YY HH:mm:ss') : '-',
          {
            type: 'text',
            value: providerCredential?.name_connector || toTitleCase(alert?.type) || '-',
            maxWidth: 100
          },
          message ? { type: 'text', value: message, maxWidth: 120 } : '-',
        ])}
      />
    </>
  );
};

export default PanelAlertsScreen;
